module.exports = __webpack_public_path__ + "static/media/Marker-closed.2a71d714.svg";